import { graphql } from 'react-relay';

import { useMutationInterop } from '@confluence/apollo-relay-interop';

import type {
	useUpdateContentDirectRestrictionsMutation$data as MutationData,
	useUpdateContentDirectRestrictionsMutation$variables as MutationVariables,
} from './__generated__/useUpdateContentDirectRestrictionsMutation.graphql.ts';

export const updateContentDirectRestrictionsMutation = graphql`
	mutation useUpdateContentDirectRestrictionsMutation(
		$cloudId: ID!
		$input: ConfluenceUpdateContentDirectRestrictionsInput!
	) {
		confluence_updateContentDirectRestrictions(cloudId: $cloudId, input: $input) {
			success
			errors {
				message
			}
			contentDirectRestrictions {
				applied {
					added {
						edit {
							__typename
						}
						view {
							__typename
						}
					}
					removed {
						edit {
							__typename
						}
						view {
							__typename
						}
					}
				}
				confluencePermissionsSummary {
					__typename
				}
			}
		}
	}
`;

export function useUpdateContentDirectRestrictions() {
	return useMutationInterop<MutationData, MutationVariables>(
		updateContentDirectRestrictionsMutation,
	);
}
